module.exports = __webpack_public_path__ + "static/media/reference-document-icon.12dbffb7.svg";